export default __webpack_public_path__ + "static/header.illustration-9bc53e60370854b480fa4004837845dd.png";